// extracted by mini-css-extract-plugin
export default {"tooltip":"RRNW5Sk6mPzFN6buEvmR","tooltipArrow":"xXfbHuytFnwfebbbPu7a","arrow":"o1lJzaPWnnw3Yh_kDqB_","text":"WfYHIMk20TvtsVTMwGyS","wrapper":"i1xdutGYOPbHgT6V1zwW"};